module.exports = __webpack_public_path__ + "static/j_f_drake_state-78848f6558aa461a3362e96bb2cba77c.png";